import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox, Col, FormGroup, Panel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add } from '../../../reducers/workOrder/material/material.actions';
import { error as getError, materials } from '../../../reducers/workOrder/material/material.reducer';
import { setNoMaterials } from '../../../reducers/workOrder/workOrders.actions';
import { dirty, noMaterials as getNoMaterials } from '../../../reducers/workOrder/workOrders.reducer';
import { ErrorAlert } from '../../ErrorAlert/ErrorAlert';
import SpinnerButton from '../../SpinnerButton/SpinnerButton';
import ConnectedMaterialForm from './MaterialForm/MaterialForm';
import './Materials.css';

// eslint-disable-next-line object-curly-newline
export const Material = ({ error, material, addMaterial, setNone, workOrderId, saveWorkOrder, noMaterials, disabled, workOrderDirty }) => (
  <Panel header="Vendor/Material Purchases" >
    {error &&
    <Row>
      <Col xs={12} >
        <ErrorAlert>{error}</ErrorAlert>
      </Col>
    </Row>
    }
    {material.length === 0 &&
    <Row>
      <Col>
        <FormGroup>
          <Checkbox className="big-checkbox" onChange={setNone(workOrderId)} checked={noMaterials} >
            No purchases.
          </Checkbox>
        </FormGroup>
      </Col>
    </Row>
    }

    {material.map(timesheet => (
      <Row key={timesheet.id} >
        <Col xs={12} >
          <ConnectedMaterialForm material={timesheet} disabled={disabled} />
        </Col>
      </Row>
    ))}
    <Row>
      { !disabled &&
      <Col xs={6} sm={3} >
        <SpinnerButton onClick={() => addMaterial(workOrderId)} >Add Purchases</SpinnerButton>
      </Col>
      }
      <Col xs={6} sm={2} >
        <SpinnerButton
          onClick={saveWorkOrder}
          bsStyle="primary"
          dirty={workOrderDirty}
          disabled={disabled}
        >
          Save
        </SpinnerButton>
      </Col>
    </Row>
  </Panel>
);

Material.defaultProps = {
  error: '',
};

Material.propTypes = {
  material: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  workOrderDirty: PropTypes.bool.isRequired,
  workOrderId: PropTypes.string.isRequired,
  error: PropTypes.string,
  saveWorkOrder: PropTypes.func.isRequired,
  addMaterial: PropTypes.func.isRequired,
  setNone: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  noMaterials: PropTypes.bool.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  material: materials(ownProps.workOrderId, state),
  workOrderDirty: dirty(state, ownProps.workOrderId),
  error: getError(state),
  noMaterials: getNoMaterials(state, ownProps.workOrderId),
});

export const mapDispatchToProps = dispatch => ({
  addMaterial: (id) => {
    dispatch(add(id));
    dispatch(setNoMaterials(id, false));
  },
  setNone: workOrderId => e => dispatch(setNoMaterials(workOrderId, e.target.checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Material);



// WEBPACK FOOTER //
// ./src/components/WorkOrder/Materials/Materials.jsx